import { render, staticRenderFns } from "./joinList.vue?vue&type=template&id=4a944e1d&scoped=true&"
import script from "./joinList.vue?vue&type=script&lang=js&"
export * from "./joinList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a944e1d",
  null
  
)

export default component.exports